export default __webpack_public_path__ + "static/media/Punto_00_Darsena_Nuova_SPA_Def.48eec89e.aac";